
window.$ = window.jQuery = require('jquery');
// window.$ = $;

require('bootstrap');




